<mat-form-field appearance="outline" class="w-100">
  <mat-label>{{ label }}</mat-label>

  <mat-select [formControl]="control" [multiple]="multiple" (selectionChange)="selectionChange.emit($event.value)">

    <input class="inputSearchSelect" [formControl]="searchControl" placeholder="Pesquisar..."
      (keydown)="$event.stopPropagation()" autocomplete="off">

    @if (filteredOptions$ | async; as options) {
    @if(isOptional && !multiple){
    <mat-option>
      Selecione
    </mat-option>
    }
    @for (item of options; track item[idField]) {
    <mat-option [value]="item[idField]">
      <div class="option-content">
        <div class="primary-text">{{ item[nameField] }}</div>
        @if (secondaryField && item[secondaryField]) {
        <div class="secondary-text">{{ item[secondaryField] }}</div>
        }
      </div>
    </mat-option>
    }

    @if (options.length === 0) {
    <mat-option disabled>Nenhum resultado encontrado.</mat-option>
    }
    } @else {
    <mat-option disabled>Carregando...</mat-option>
    }
  </mat-select>

  @if (control.hasError('required') || control.invalid) {
  <mat-error>{{ errorMessage }}</mat-error>
  }
</mat-form-field>